import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useFetchUsers = (queryParams, shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("users", { params });
		return res.data;
	};

	return useQuery(["users", queryParams], () => fetch(), {
		...fetchConfig,
		enabled: shouldFetch,
	});
};

export default useFetchUsers;
